import { FaStar } from "react-icons/fa";
import { RattingBoxWrapper } from './styled.js'

function RatingBox({ data, pointStar }) {
    let count = 0;
    data.forEach(element => {
        count += element
    })
    return (
        <RattingBoxWrapper>
            <div className="rating_box">
                <h6 className='rating_box_title'>{pointStar}  <FaStar className="mx-5" /> {count} Đánh giá</h6>
                <ul className='rating_box_list'>
                    {
                        data.map((item, index) => (
                            <li className='rating_box_list_item mb-10' key={index}>
                                <div className='rating_box_list_item_left'>
                                    <div>
                                        <p className="text-black medium s-18">{5 - index}</p>
                                        <FaStar className="star_icon mr-5" />
                                    </div>
                                    <div className='progress_bar'>
                                        <span style={{ width: `${count === 0 ? 0 : Math.round(item / count * 100, 2)}%` }}></span>
                                    </div>
                                </div>
                                <span className='rating_box_list_item_percent'>{count === 0 ? 0 : Math.round(item / count * 100, 2)}%</span>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </RattingBoxWrapper>
    )
}
export default RatingBox